var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-crf',{attrs:{"crfId":"tbFrmIPAQSF","crfTitle":"Your Activity Levels"}})
}
var staticRenderFns = []

export { render, staticRenderFns }